import qs from 'qs';

export const objectToQueryParams = (obj: Record<string, unknown>): `?${string}` => {
  return `?${qs.stringify(obj, { arrayFormat: 'comma', encoder: encodeURIComponent })}`;
};
